

var _angular = require("angular");
define(['angular', 'squid/module', 'text!./template.html', 'xo-models/src/fi/lib/fiApis', 'xo-beaver/dist/logger', 'xo-wallet-components/src/add-card/directive', 'xo-validation/dist/directive', 'xo-ui-components/src/tooltip/directive', 'xo-ui-components/src/dropdown/directive', 'xo-page-components/src/value-props/directive', 'xo-page-components/src/done/directive'], function (angular, module, template) {
  return angular.module('hermes.page.xo-add-card.directive', ['squid', 'fi.apis', 'beaver', 'xo-add-card.directive', 'xo-validation.directive', 'xo-tooltip.directive', 'xo-dropdown.directive', 'xo-value-props.directive', 'xo-done.directive']).directive('xoPageAddCardPage', function ($rootScope) {
    return {
      template: template,
      scope: {
        token: '=?'
      },
      controller: function controller($scope, $rootScope, $state, $stateParams, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel,
      // eslint-disable-line no-shadow
      $ShippingAddressModel, $locale, $fiApis, $logger) {
        function populateInfoMessage() {
          var msg;
          if ($stateParams.gaming === '1') {
            msg = $locale.content.get('creditcard.noEligibleFI');
          } else if ($stateParams.country === 'DE') {
            if ($stateParams.fiType === 'BANK') {
              msg = $locale.content.get('creditcard.cannotUseBank');
            } else {
              msg = $locale.content.get('creditcard.cannotUseCard');
            }
          } else {
            msg = $locale.content.get('creditcard.noFIContingency');
          }
          $scope.message = {
            msgs: [msg],
            type: 'error'
          };
        }
        populateInfoMessage();
        $scope.pagetitle = $locale.content.get('addCard.addACard');
        $scope.callbacks = {
          finish: function finish() {
            var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
            var checkoutAppData = $CheckoutAppDataModel.instance($rootScope.token);
            var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
            var shippingAddress = $ShippingAddressModel.instance('123');
            var showGenericError = function showGenericError(code) {
              return function () {
                $state.go('checkout.genericError', {
                  code: code
                });
              };
            };
            var makePayment = function makePayment() {
              return checkoutSession.action('createPayment', {
                data: {
                  payer_id: checkoutSession.payer.id,
                  intent: checkoutCart.payment_action
                },
                success: function success(result) {
                  $rootScope.paymentComplete = true;
                  $logger.info('wps_cart_to_txn_mapping', {
                    cart_id: $rootScope.token,
                    txn_id: result.transactionDetails && result.transactionDetails.id,
                    txn_receipt_id: result.transactionDetails && result.transactionDetails.receipt_id
                  });
                  return $state.go('checkout.done');
                },
                contingencies: {
                  TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                  PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
                  DUPLICATE_TRANSACTION: showGenericError('PAYMENT_ALREADY_DONE')
                }
              });
            };
            var authorize = function authorize() {
              checkoutSession.action('authorize', {
                success: function success() {
                  if (checkoutAppData.doec_on_approve()) {
                    return makePayment();
                  } else {
                    $state.go('checkout.end');
                  }
                }
              });
            };
            var setStickyInstrument = function setStickyInstrument() {
              if ($stateParams.mode !== 'signup') {
                return;
              }
              var stickyInstrument = checkoutSession.selectedFuturePaymentInstrument ? undefined : checkoutSession.getSelectedStickyInstrument();
              if (stickyInstrument) {
                return checkoutSession.action('setStickyFI', {
                  data: {
                    instrument_id: stickyInstrument.instrument_id
                  }
                });
              }
            };
            if (shippingAddress.isNew) {
              shippingAddress.save({
                data: shippingAddress,
                success: function success() {
                  _angular.$q.when(setStickyInstrument())["catch"](function (err) {
                    $logger.info('setStickyFI Failed', err);
                  }).then(function () {
                    return authorize();
                  });
                }
              });
            } else {
              _angular.$q.when(setStickyInstrument())["catch"](function (err) {
                $logger.info('setStickyFI Failed', err);
              }).then($fiApis.patchCvv(checkoutSession)).then(authorize(), function (err) {
                $logger.error('patchCvv error', err);
              });
            }
          }
        };
      }
    };
  });
});
_angular.$q;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-card/directive.js
// module id = ./pages/xo-add-card/directive.js
// module chunks = 0